export const blockIconsTravelIcecreamNew = (
	<span className='material-symbols-outlined'>icecream</span>
);
